import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LeftPanel from "shared-components/LeftPanel";
import {
  cacheManager,
  getMemberAccountNo,
  printRenewalInvoiceMenu,
} from "helpers/util-common";
import { getEntitlementListAction } from "layout/actions/entitlement.action";
import MenuItems from "./components/MenuItems";
import NavigationLogo from "./components/NavigationLogo";
import { find } from "lodash";
import { MENU_TITLES } from "models/common.models";
import { ModuleUrls } from "models";

const MemberMobileMenu = () => {
  const [entitlementList, setEntitlementList] = useState();
  const [activeMenu, setActiveMenu] = useState(0);
  const [isRenew, setIsRenew] = useState();
  const [customMenu, setCustomMenu] = useState([]);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { IsAuthorised } = useSelector((state) => state.commonReducer);

  const dispatch = useDispatch();
  useEffect(() => {
    setOpen(false);
  }, [location]);

  const getMenuMappedList = () => {};

  const getEntitlementList = (accountNo, cb) => {
    getEntitlementListAction(accountNo, dispatch, cb);
  };

  const mobileMenuHandler = useCallback(() => {
    setOpen(!open);
  }, [open]);

  const featureFlag = cacheManager.getItem("flagFeature")
    ? JSON.parse(cacheManager.getItem("flagFeature"))
    : null;

  useEffect(() => {
    if (isRenew) {
      setCustomMenu((prevItems) => {
        if (prevItems.length === 0) {
          return [...prevItems, printRenewalInvoiceMenu(1)];
        }
        return prevItems;
      });
    }
  }, [isRenew]);

  useEffect(() => {
    if (getMemberAccountNo()) {
      getEntitlementList(getMemberAccountNo(), (response) => {
        if (response?.menuList?.length > 0) {
          const membershipMenuList = find(response?.menuList, {
            title: MENU_TITLES.MEMBERSHIP,
          });
          const isRenew = find(membershipMenuList.child, {
            title: MENU_TITLES.RENEW_MEMBERSHIP,
          });
          setIsRenew(isRenew);
        }
        setEntitlementList(response);
      });
    }
  }, []);

  return (
    <div className="mobile-member-menu-wrapper">
      <div
        className="member-menu-bar"
        role="button"
        onClick={mobileMenuHandler}
      >
        {MENU_TITLES.MEMBERSHIP} <i className="fas fa-bars"></i>
      </div>
      <div className="member-mobile-navigation-container">
        <div
          className={`mobileNavWrapper astm-nav-section bg-primary position-relative offcanvas-overlay ${
            open ? "show" : ""
          }`}
        >
          <div className="container-xl offcanvas-content">
            <NavigationLogo handler={mobileMenuHandler} />
            <div className="nav-container mt-4">
              <div className="main-nav-desktop navbar navbar-expand-md p-0 main-nav navbar-dark astm-navbar ms-auto overflow-auto position-static">
                <ul className="navItemWrapper d-flex navbar-nav m-auto navbar-nav">
                  <MenuItems
                    title={MENU_TITLES.MEMBERSHIP}
                    onClick={() => setActiveMenu(activeMenu === 1 ? 0 : 1)}
                    active={activeMenu === 1}
                  >
                    {entitlementList && (
                      <LeftPanel
                        location={location}
                        IsAuthorised={IsAuthorised}
                        memberHost={process.env.REACT_APP_MEETINGAPP_URL}
                        customMenu={customMenu}
                        isMemberApp={false}
                        isMainMenu={false}
                        hideUserDetail={true}
                        activePath={ModuleUrls.MyCommmittees}
                        entitlementList={entitlementList}
                        getMenuMappedList={getMenuMappedList}
                        globalLinksURL={{
                          profile: process.env.REACT_APP_GLOBAL_PROFILE_URL,
                          membership: ModuleUrls.MyASTM,
                          campus: process.env.REACT_APP_GLOBAL_ASTM_CAMPUS_URL,
                          meetingsSymposia: process.env.REACT_APP_GLOBAL_MEETING_SYMPOSIA_URL,
                          orders: process.env.REACT_APP_GLOBAL_ORDERS_URL,
                          compass: process.env.REACT_APP_GLOBAL_COMPASS_URL,
                          tracker: process.env.REACT_APP_GLOBAL_TRACKERS_URL,
                        }}
                        featureFlag={featureFlag}
                      />
                    )}
                  </MenuItems>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`offcanvas-backdrop ${open ? "show" : ""}`}></div>
    </div>
  );
};

export default React.memo(MemberMobileMenu);
